/**
 * 這次按鍵是否屬於輸入法組字（注音、日文等的選字），而不是使用者要送出／換行。
 *
 * - 一般瀏覽器：組字中的 keydown 有 isComposing = true
 * - macOS Safari：按 Enter 選字時，keydown 在 compositionend 之後才觸發，isComposing 已是 false，
 *   只能靠 keyCode 229（輸入法處理中）辨識
 *
 * React 的 SyntheticKeyboardEvent 沒有 isComposing，必須讀 nativeEvent。
 *
 * @param {React.KeyboardEvent} event
 * @returns {boolean}
 */
export const isImeComposingKey = (event) =>
  event.nativeEvent.isComposing || event.nativeEvent.keyCode === 229;
